import React, { useState, useEffect } from 'react';
import CalendarWeekView from './CalendarWeekView';
import AbsenceMgntForm from './AbsenceMgntForm';
import FullDayAbsenceForm from './FullDayAbsenceForm';
import AbsenceDetailModal from './AbsenceDetailModal';
import NavigationWeek from './NavigationWeek';
import GuardList from './GuardList';
import { format, startOfWeek, addDays } from 'date-fns';
import es from 'date-fns/locale/es';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import { fetchAusenciasProfesor, fetchFranjasHorarias, fetchCeldasHorariasProfesor, fetchDetalleGuardia } from './Guardias-Api';
import { getUserLoggedLS } from '../../util/LocalStorageUtils';

const ProfessorDashboard = ({ setTitulo }) => {
    const [profesorId, setProfesorId] = useState(null);
    const [profesorName, setProfesorName] = useState(null);
    const [profesorApellido, setProfesorApellido] = useState(null);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [ausenciasSemana, setAusenciasSemana] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [franjasHorarias, setFranjasHorarias] = useState([]);
    const [celdasHorarias, setCeldasHorarias] = useState([]);
    const [isDetailModalOpen, setDetailModalOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedFranja, setSelectedFranja] = useState(null);
    const [selectedCeldaHorariaId, setSelectedCeldaHorariaId] = useState(null);
    const [ausenciasDetalle, setAusenciasDetalle] = useState([]);
    const [profesoresGuardiaDetalle, setProfesoresGuardiaDetalle] = useState([]);
    const [detalleGuardiaLoading, setDetalleGuardiaLoading] = useState(false);
    const [detalleGuardiaError, setDetalleGuardiaError] = useState(null);
    const [showAbsenceForm, setShowAbsenceForm] = useState(false);
    const [showFullDayAbsenceForm, setShowFullDayAbsenceForm] = useState(false);
    const [serial, setSerial] = useState(0);

    setTitulo("Guardias");        

    useEffect(() => {
        let uslog = getUserLoggedLS();
        if (!uslog) {
            window.location.href = '/signin/';
        } else {
            setProfesorId(uslog.id);            
            setProfesorName(uslog.usuarioMobEnt.nombre);
            setProfesorApellido(uslog.usuarioMobEnt.apellidos);
        }
    }, []);

    useEffect(() => {
        fetchInitialData();
    }, [currentDate]); 

    const alTerminarCargaAusencias = (data) => {
        setAusenciasSemana(data);
        setLoading(false);        
    }

    const alTerminarCargaCeldasHorarias = (data) => {
        setCeldasHorarias(data);
        console.log("Celdas Horarias: ", data);
    }

    const fetchInitialData = async () => {
        setLoading(true);
        setError(null);
        try {
            fetchFranjasHorarias(setFranjasHorarias);
            if (!profesorId) {
                let userLogged = getUserLoggedLS();
                setProfesorId(userLogged.id);
            }
            fetchCeldasHorariasProfesor(profesorId, alTerminarCargaCeldasHorarias);
            const startDate = startOfWeek(currentDate, { locale: es, weekStartsOn: 1 });
            const endDate = addDays(startDate, 4); // Suponiendo 5 días laborales
            fetchAusenciasProfesor(profesorId, format(startDate, 'yyyy-MM-dd'), format(endDate, 'yyyy-MM-dd'), alTerminarCargaAusencias);            
        } catch (err) {
            setError('Error al cargar los datos de ausencias y guardias');
            setLoading(false);
        }
    };

    const handleNavigateWeek = (offset) => {
        setCurrentDate(prevDate => {
            const newDate = new Date(prevDate);
            newDate.setDate(newDate.getDate() + (7 * offset));
            return newDate;
        });
    };

    const openDetailModal = async (date, franja, celdaHorariaId) => {
        const fechaFormateada = format(date, 'yyyy-MM-dd');
        setSelectedDate(fechaFormateada);
        setSelectedFranja(franja);
        setSelectedCeldaHorariaId(celdaHorariaId || null);
        setDetalleGuardiaError(null);
        setDetalleGuardiaLoading(true);
        setDetailModalOpen(true);
        try {
            const detalle = await fetchDetalleGuardia(franja.id, fechaFormateada);
            setAusenciasDetalle(detalle?.ausencias || []);
            setProfesoresGuardiaDetalle(detalle?.profesoresGuardia || []);
        } catch (err) {
            console.error("Error al cargar detalle de guardia", err);
            setDetalleGuardiaError('No se pudo cargar el detalle de la guardia');
            setAusenciasDetalle([]);
            setProfesoresGuardiaDetalle([]);
        } finally {
            setDetalleGuardiaLoading(false);
        }
    };

    const closeDetailModal = () => {
        setDetailModalOpen(false);
        setDetalleGuardiaError(null);
        setDetalleGuardiaLoading(false);
        setProfesoresGuardiaDetalle([]);
        handleAbsenceRegistered();
    };

    const handleAbsenceRegistered = () => {
        recargaDetalleGuardias();
        fetchInitialData(); // Recargar los datos después de registrar una ausencia
    };

    const recargaDetalleGuardias = () => {
        // Esto fuerza recarga de detalle guardias inferior
        //   crear copia de currentDate en otra variable, poner fecha actual en currentDate y finalmente volver a poner la fecha original
        // const currentDateCopy = new Date(currentDate);
        // setCurrentDate(new Date); // Mantener la fecha actual
        // setCurrentDate(currentDateCopy); // Volver a la fecha original
        ////////////////
        setSerial(serial + 1);
    }

    return (
        <div className="container mt-4">
            <h2 style={{textAlign: 'center'}}>Panel del Profesor</h2>
            {/* <h6 style={{textAlign: 'center'}}>{profesorName} {profesorApellido}</h6> */}
            <small className="text-muted d-block text-center">{profesorName} {profesorApellido}</small>
            <NavigationWeek currentDate={currentDate} onNavigate={handleNavigateWeek} />

            <div className="text-end mb-3">
                <button className="btn btn-warning me-2" data-bs-toggle="modal" data-bs-target="#modalRegistrarAusencia">
                    <i className="bi bi-person-x"></i> Gestionar Ausencias
                </button>
                {/* <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#modalAusenciaDiaCompleto">
                    <i className="bi bi-calendar-x"></i> Ausencia Día Completo
                </button> */}
            </div>

            {loading ? (
                <div className="alert alert-info">Cargando datos 1...</div>
            ) : error ? (
                <div className="alert alert-danger">{error}</div>
            ) : (
                <CalendarWeekView weeklyData={ausenciasSemana} currentDate={currentDate} openDetailModal={openDetailModal} profesorId={profesorId} timeSlots={franjasHorarias} celdasHoradias={celdasHorarias} />
            )}

            <GuardList profesorId={profesorId} currentDate={currentDate} serial={serial} />

            <AbsenceMgntForm                
                franjasHorarias={franjasHorarias}
                onClose={() => {
                    const modal = document.getElementById('modalRegistrarAusencia');
                    if (modal) {
                        const modalInstance = bootstrap.Modal.getInstance(modal);
                        if (modalInstance) {
                            modalInstance.hide();
                        }
                    }
                }}
                onAbsenceRegistered={handleAbsenceRegistered}
                profesorId={profesorId}
            />

            <FullDayAbsenceForm
                onClose={() => {
                    const modal = document.getElementById('modalAusenciaDiaCompleto');
                    if (modal) {
                        const modalInstance = bootstrap.Modal.getInstance(modal);
                        if (modalInstance) {
                            modalInstance.hide();
                        }
                    }
                }}
                onAbsenceRegistered={handleAbsenceRegistered}
                profesorId={profesorId}
            />

            {selectedDate && selectedFranja && (
                <AbsenceDetailModal
                    isOpen={isDetailModalOpen}
                    onClose={closeDetailModal}
                    fecha={selectedDate}
                    franja={selectedFranja}
                    ausencias={ausenciasDetalle}
                    celdaHorariaId={selectedCeldaHorariaId}
                    profesoresGuardia={profesoresGuardiaDetalle}
                    loading={detalleGuardiaLoading}
                    error={detalleGuardiaError}
                    loggedProfesorId={profesorId}
                />
            )}
        </div>
    );
};

export default ProfessorDashboard;            
